import { paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { Client, PaginatedResponse, ClientUser } from '../../api/models'

import { API, CustomAxiosConfig } from './types'

import fileDownload from 'js-file-download'

export interface ExportProps {
  fields: string[]
}

class UsersAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  retrieve = async (clientGuid: string, guid: string, config: CustomAxiosConfig = {}): Promise<ClientUser> => {
    const response = await this.api.get(`/accounts/clients/${clientGuid}/users/${guid}`, config)
    return rawTransform(ClientUser)(response.data)
  }

  list = async (guid: string, config: CustomAxiosConfig = {}): Promise<PaginatedResponse<ClientUser>> => {
    const response = await this.api.get(`/accounts/clients/${guid}/users`, config)
    return paginatedTransform(ClientUser)(response.data)
  }

  create = async (guid: string, data: any = {}, config: CustomAxiosConfig = {}): Promise<ClientUser> => {
    const response = await this.api.post(`/accounts/clients/${guid}/users`, data, config)
    return rawTransform(ClientUser)(response.data)
  }

  patch = async (
    clientGuid: string,
    guid: string,
    data: any,
    config: CustomAxiosConfig = {}
  ): Promise<ClientUser> => {
    const response = await this.api.patch(
      `/accounts/clients/${clientGuid}/users/${guid}`,
      data,
      config
    )
    return rawTransform(ClientUser)(response.data)
  }
}

export class Clients {
  api: API

  constructor(api: API) {
    this.api = api
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<Client> => {
    const response = await this.api.get(`/accounts/clients/${guid}`, config)
    return rawTransform(Client)(response.data)
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Client>> => {
    const response = await this.api.get('/accounts/clients', config)
    return paginatedTransform(Client)(response.data)
  }

  create = async (data: any, config: CustomAxiosConfig = {}): Promise<Client> => {
    const response = await this.api.post('/accounts/clients', data, config)
    return rawTransform(Client)(response.data)
  }

  patch = async (slug: string, data: any, config: CustomAxiosConfig = {}): Promise<Client> => {
    const response = await this.api.patch(`/accounts/clients/${slug}`, data, config)
    return rawTransform(Client)(response.data)
  }

  export = async ({ fields }: ExportProps) => {
    const params = { fields: fields.join(',') }
    const response = await this.api.axiosInstance({
      url: 'accounts/clients/export',
      params,
      responseType: 'blob'
    })
    fileDownload(response.data, 'clients.csv')
  }

  get users() {
    const api = new UsersAPI(this.api)
    Object.defineProperty(this, 'users', { value: api })
    return api
  }
}
